import { render, staticRenderFns } from "./login-password.vue?vue&type=template&id=3f5ad08a&scoped=true&"
import script from "./login-password.vue?vue&type=script&lang=js&"
export * from "./login-password.vue?vue&type=script&lang=js&"
import style0 from "./login-password.vue?vue&type=style&index=0&id=3f5ad08a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5ad08a",
  null
  
)

export default component.exports